import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import { getItem } from '../api';
import ListingImage from './ListingImage';

// Owner Bookings & Cancellation v2 doc, Story 14 - customer/owner/admin/delivery-person can all
// see the item's image + details from a closable popup right on a booking listing, instead of
// navigating away to the item page (which the customer-facing verticals also don't expose to
// admin/delivery roles at all). Read-only, no auth-sensitive fields - GET /:vertical/items/:id is
// public, so this is safe for every role that can see a booking in the first place.
export default function ProductDetailsModal({ itemId, show, onHide, editHref }) {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show || !itemId) return;
    setItem(null);
    setError('');
    setLoading(true);
    getItem(itemId)
      .then(setItem)
      .catch(() => setError('Could not load this item\'s details.'))
      .finally(() => setLoading(false));
  }, [show, itemId]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Product details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <Spinner animation="border" size="sm" role="status" />}
        {error && <Alert variant="danger" className="py-2">{error}</Alert>}
        {item && (
          <>
            {item.images?.[0] && (
              <ListingImage
                src={item.images[0]} alt={item.name} sizes="(max-width: 768px) 100vw, 480px"
                className="w-100 rounded mb-3" style={{ maxHeight: 240, objectFit: 'cover' }}
              />
            )}
            <h6>{item.name}</h6>
            {item.location && <div className="small text-muted mb-2">{item.location}</div>}
            {item.price != null && (
              <div className="small mb-2">₹{item.price.toLocaleString('en-IN')}/{item.priceUnit}</div>
            )}
            {item.description && <p className="small mb-2">{item.description}</p>}
            {item.attributes && Object.keys(item.attributes).length > 0 && (
              <ul className="small text-muted mb-0 ps-3">
                {Object.entries(item.attributes)
                  .filter(([key, value]) => value !== '' && value != null && !['ownerId', 'testTag'].includes(key))
                  .map(([key, value]) => (
                    <li key={key}>{key}: {Array.isArray(value) ? value.join(', ') : String(value)}</li>
                  ))}
              </ul>
            )}
          </>
        )}
      </Modal.Body>
      {item && editHref && (
        <Modal.Footer>
          {/* Admin listing editing - the website owner opens the same ItemForm the listing's
              own owner uses, straight from this details popup. */}
          <Button as={Link} to={editHref} variant="outline-secondary" size="sm" onClick={onHide}>
            Edit details
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
